import ContainerValidation from './Components/ContainerValidation';
import HeaderValidation from './Components/HeaderValidation';
import BodyValidation from './Components/BodyValidation';
import React from 'react';
import { IconIdentityCardProcess, IconVisitorManagement } from '../../../../components/buttons/IconButtons';
import routes from '../../../../Routes/routes';
import { statusBorderColor, statusColor, statusFontColor } from '../../../../enums/statusColorEnum';
import { status, STATUS_MODEL } from '../../../../enums/statusEnum';
import ProcessCard from './Components/ProcessCard';
import RegistrationProcessApp from './Functionality/RegistrationProcessApp';
import {getUrlParameters, invitationIsBlocked, invitationIsExpired} from "./Model/Model";
import {EMPTY_VALUES} from "../../../../Apis/functions";
import ValidatedFailBody from "./ValidatedFailBody";
import {getIdentityValidationCard} from "../../../../enums/IdentityValidationCardEnum";

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
const RegistrationProcess = () => {

    const {
        id,
        guardFlowId,
        t,
        navigate,
        getInvitationById,
        userRestriction,
        url,
        documentUrl,
        identityValidationDenied,
    } = RegistrationProcessApp();


    invitationIsBlocked(getInvitationById?.invitation, navigate);
    invitationIsExpired(getInvitationById?.invitation, navigate);

    const isDocumentationValidated = getInvitationById?.invitation?.documentationValidated
    const isIdentityValidation = userRestriction?.validationVisitor
    const identityValidation = getInvitationById?.invitation?.identityValidation

    /**
     * Special identity-validation card display (validated / in review / optional / required).
     * Returns null when no special case applies, so each attribute falls back to
     * the generic status maps.
     */
    const identityCard = getIdentityValidationCard(identityValidation, isIdentityValidation)

    return (
        <ContainerValidation>
            <HeaderValidation
                url={getUrlParameters({url: routes.invitationDetails.invitation, id, guardFlowId})}
            />

            <BodyValidation showBtnNext={false} url={getUrlParameters({url: routes.invitationDetails.identityValidation, id, guardFlowId})}>
                <>
                    { identityValidationDenied ?
                        <ValidatedFailBody title={"identity_validation_denied"}/>
                        :
                        getInvitationById?.invitation &&
                        <>
                            <div className="d-flex flex-column gap-3">
                                <p className="fs-24-to-18 ibl-font-w-600 font-color-general-950 text-center">{t("registration_process")}</p>
                                <p className="fs-20-to-14 ibl-font-w-400 font-color-general-950 text-center">
                                    { guardFlowId ?
                                        <>
                                            { (getInvitationById?.invitation?.identityValidation === STATUS_MODEL.PENDING_TO_UPLOAD_INFORMATION
                                                || getInvitationById?.invitation?.statusId === STATUS_MODEL.PENDING_TO_UPLOAD_INFORMATION) ?
                                                t("you_will_guide_the_visitor_through_the_registration_process")
                                                :
                                                t("to_complete_visitor_registration_you_will_guide_them")
                                            }
                                        </>
                                        :
                                        t("registration_process_subtitle")}
                                </p>
                            </div>

                            <div className="row w-100 g-3 ">
                                <ProcessCard
                                    click={ url != null  ? () => navigate(url) : null }
                                    background={identityCard ? identityCard.background : statusColor[identityValidation]}
                                    fontColor={identityCard ? identityCard.fontColor : statusFontColor[identityValidation]}
                                    borderColor={identityCard ? identityCard.borderColor : statusBorderColor[identityValidation]}
                                    legend={identityCard ? t(identityCard.legend) : t(status[identityValidation])}
                                    icon={<IconIdentityCardProcess className={'w-60'} />}
                                    titleCard={t("identity_validation_external")}
                                />

                                <ProcessCard
                                    click={documentUrl != null  ? () => navigate(documentUrl) : null }
                                    background={isDocumentationValidated === false ? statusColor[STATUS_MODEL.APPROVED] :statusColor[getInvitationById?.invitation?.statusId]}
                                    fontColor={isDocumentationValidated === false ? statusFontColor[STATUS_MODEL.APPROVED] :statusFontColor[getInvitationById?.invitation?.statusId]}
                                    borderColor={isDocumentationValidated === false ? statusBorderColor[STATUS_MODEL.APPROVED] :statusBorderColor[getInvitationById?.invitation?.statusId]}
                                    legend={isDocumentationValidated === false ? t("validation_not_required") : t(status[getInvitationById?.invitation?.statusId])}
                                    icon={<IconVisitorManagement />}
                                    titleCard={t("visitor_documentation")}
                                />

                            </div>
                        </>
                    }
                </>
            </BodyValidation>
        </ContainerValidation>
    )

}

export default RegistrationProcess
